export { default } from './TaskItem';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksList/TaskItem/index.js